"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
exports.MenuItem = (0, react_1.forwardRef)(({ children, sx = [], faded, selected, noSelectBackground, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { sx: [
            ({ palette }) => ({
                ...(faded && {
                    [`& .${material_1.listItemTextClasses.primary}, .${material_1.typographyClasses.root}`]: {
                        color: palette.gray[60],
                    },
                    [`& .${material_1.listItemIconClasses.root}, & svg`]: {
                        color: palette.gray[40],
                    },
                }),
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...props, ref: ref, 
        // noSelectBackground is needed for scenarios where we don't need
        // selected styles to be applied once the menu item is selected
        // A typical example is when we have a checkbox present in the menuItem,
        // we wouldn't need the select styles in that case, since the checkbox can be
        // used to determine if the menuItem was selected or not
        selected: !noSelectBackground && selected, children: children }));
});
exports.MenuItem.displayName = "MenuItem";
